import { useCallback, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';
import GridPager from '../../Components/GridPager';
import ResourceGrid from '../../Components/ResourceGrid';
import SortFilter from '../../Components/SortFilter';
import {
  fetchCollection,
  fetchCollectionResourcesById,
  removeResourceFromCollection,
} from '../../lib/api';
import DownloadAll from '../../Components/DownloadAll';
import Modal from '../../Components/Modal';

export const Collection = () => {
  const [pageParams] = useSearchParams();
  const sortBy = useMemo<string>(
    () => pageParams.get('sort') || 'relevance',
    [pageParams]
  );

  const [showDownloadAllModal, setDownloadAllModal] = useState<boolean>(false);

  const collectionId: number = useMemo<number>(() => {
    const paramsId: string | null = pageParams.get('id');
    if (paramsId) {
      return parseInt(paramsId);
    } else return 0;
  }, [pageParams]);
  const page: number = parseInt(pageParams.get('page') || '1');
  // const title: string = pageParams.get('name') || '';

  const {
    isLoading: resourcesLoading,
    data: resourcesData,
    refetch: refetchResources,
  } = useQuery({
    queryKey: ['collection_resources', collectionId, page, sortBy],
    queryFn: () =>
      collectionId
        ? fetchCollectionResourcesById(collectionId, page, sortBy)
        : undefined,
    enabled: !!collectionId,
  });

  const { isLoading: collectionLoading, data: collectionData } = useQuery({
    queryKey: ['collection_detail', collectionId],
    queryFn: () => (collectionId ? fetchCollection(collectionId) : undefined),
    enabled: !!collectionId,
  });

  const removeResourceFromCollectionHandler = useCallback(
    async (resourceId: number) => {
      if (resourceId && collectionId) {
        const success = await removeResourceFromCollection(
          collectionId,
          resourceId
        );
        if (success) {
          refetchResources();
        }
      }
    },
    [collectionId, refetchResources]
  );

  const handleDownloadCollectionClick = () => {
    setDownloadAllModal(true);
  };

  const handleDownloadAllClose = () => {
    setDownloadAllModal(false);
  };

  return (
    <div className="collection-resources-wrapper">
      {!collectionLoading && <h2>{collectionData?.name}</h2>}
      {resourcesLoading && <p>Loading...</p>}
      {collectionData?.public === 0 && (
        <>
          <Modal
            showBack={true}
            title="Download collection files"
            isOpened={showDownloadAllModal}
            onClose={handleDownloadAllClose}
          >
            <DownloadAll collectionId={collectionId} collectionSize={resourcesData?.total ?? 0} />
          </Modal>
          {!!resourcesData?.data.length && (
            <div className="collection-info-wrapper">
              <button onClick={handleDownloadCollectionClick}>
                Download Collection
              </button>
              <SortFilter sortBy={sortBy} />
            </div>
          )}
        </>
      )}
      <ResourceGrid
        resources={resourcesData?.data || []}
        // publicCollection={collectionData?.public === 1}
        onRemoveResource={
          collectionData?.public === 1
            ? undefined
            : removeResourceFromCollectionHandler
        }
      />
      <GridPager
        totalResults={resourcesData?.total || 0}
        currentPage={page}
        pageLength={12}
        baseUrl={`/collection?id=${collectionId}`}
      />
    </div>
  );
};
